import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

const DEFAULT_W = 40;
const DEFAULT_H = 27;
const COMPACT_W = 28;
const COMPACT_H = Math.round(COMPACT_W * (DEFAULT_H / DEFAULT_W));
/** Dense rows (e.g. match hub match info). */
const MINI_W = 22;
const MINI_H = Math.round(MINI_W * (DEFAULT_H / DEFAULT_W));

export const getCountryFlagStyles = (
  theme: Theme,
  size: 'default' | 'compact' | 'mini' = 'default'
) => {
  const w = size === 'mini' ? MINI_W : size === 'compact' ? COMPACT_W : DEFAULT_W;
  const h = size === 'mini' ? MINI_H : size === 'compact' ? COMPACT_H : DEFAULT_H;
  return StyleSheet.create({
    wrap: {
      width: w,
      height: h,
      borderRadius: 4,
      overflow: 'hidden',
      backgroundColor: theme.gray[100],
      borderWidth: 0,
    },
    image: {
      width: w,
      height: h,
    },
    placeholder: {
      width: w,
      height: h,
      borderRadius: 4,
      backgroundColor: theme.gray[100],
      borderWidth: 0,
    },
  });
};
